import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';

import { LayoutService } from '@app/layout/layout.service';
import { MaterialModalService } from '@shared/material-modal/material-modal.service';
import { isTruthy } from '@shared/utils';

import * as LayoutActions from '../../store/layout.actions';
import { MOBILE_LIST_SIZE } from '../../store/layout.effects';
import {
  getGlobalSearchLoading,
  getGlobalSearchPhrase,
  getGlobalSearchResultsWithCompaniesMobile,
} from '../../store/layout.selectors';

@Component({
  selector: 'mojo-mobile-global-search-modal-content',
  templateUrl: './mobile-global-search-modal-content.component.html',
  styleUrls: ['./mobile-global-search-modal-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileGlobalSearchModalContentComponent implements OnInit, OnDestroy {
  subs = new Subscription();
  globalSearch = new UntypedFormControl('');
  globalSearchLoading$ = this.store.select(getGlobalSearchLoading);
  searchResults$ = this.store.select(getGlobalSearchResultsWithCompaniesMobile);

  constructor(
    private materialModalService: MaterialModalService,
    private store: Store<{}>,
    private layoutService: LayoutService,
  ) {}

  ngOnInit() {
    this.setSearchedPhrase();
    this.emitValueOnInputChange();
    this.queryForGlobalSearchResults();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  clearGlobalSearch() {
    this.store.dispatch(LayoutActions.layoutHeaderClearGlobalSearch());
    this.globalSearch.reset();
  }

  closeModal() {
    this.clearGlobalSearch();
    this.materialModalService.close();
  }

  /**
   * Method sets searched phrase
   * used when transition: desktop -> mobile to persist search phrase
   */
  private setSearchedPhrase() {
    this.subs.add(
      this.store
        .select(getGlobalSearchPhrase)
        .pipe(first(isTruthy))
        .subscribe((search) => {
          this.globalSearch.setValue(search);
        }),
    );
  }

  private emitValueOnInputChange() {
    this.subs.add(
      this.globalSearch.valueChanges.subscribe((search) => {
        this.layoutService.emitGlobalSearch(search);
      }),
    );
  }

  private queryForGlobalSearchResults() {
    this.subs.add(
      this.layoutService.globalSearchMobile$.subscribe((search) => {
        this.store.dispatch(
          LayoutActions.layoutHeaderLoadGlobalSearch({
            search,
            apiParams: { size: MOBILE_LIST_SIZE },
          }),
        );
      }),
    );
  }

  goToPage(_) {
    this.closeModal();
  }
}
